import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { defaultValue } from '../model/case.model';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const initialState = {
    loading: false,
    errorMessage: null,
    cases: [],
    case: defaultValue,
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
const apiUrl = API_ROUTES.kases;
// Async Actions
export const getCases = createAsyncThunk('caseManagement/fetch_cases', async ({ page, size, sort }) => {
    const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
    return axios.get(requestUrl);
});
export const getCase = createAsyncThunk('caseManagement/fetch_case', async (id) => {
    const requestUrl = `${apiUrl}/${id}`;
    return axios.get(requestUrl);
}, { serializeError: serializeAxiosError });
export const createCase = createAsyncThunk('caseManagement/create_case', async (caseData) => {
    const result = await axios.post(apiUrl, caseData);
    return result;
}, { serializeError: serializeAxiosError });
export const updateCase = createAsyncThunk('caseManagement/update_case', async (caseData) => {
    const result = await axios.put(`${apiUrl}/${caseData.id}`, caseData);
    return result;
}, { serializeError: serializeAxiosError });
export const deleteCase = createAsyncThunk('caseManagement/delete_case', async (id) => {
    const requestUrl = `${apiUrl}/${id}`;
    const result = await axios.delete(requestUrl);
    return result;
}, { serializeError: serializeAxiosError });
export const CaseManagementSlice = createSlice({
    name: 'caseManagement',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getCase.fulfilled, (state, action) => {
            state.loading = false;
            state.case = action.payload.data;
        })
            .addCase(deleteCase.fulfilled, state => {
            state.updating = false;
            state.updateSuccess = true;
            state.case = defaultValue;
        })
            .addMatcher(isFulfilled(getCases), (state, action) => {
            state.loading = false;
            state.cases = action.payload.data;
            state.totalItems = parseInt(action.payload.headers['x-total-count'], 10);
        })
            .addMatcher(isFulfilled(createCase, updateCase), (state, action) => {
            state.updating = false;
            state.loading = false;
            state.updateSuccess = true;
            state.case = action.payload.data;
        })
            .addMatcher(isPending(getCases, getCase), state => {
            state.errorMessage = null;
            state.updateSuccess = false;
            state.loading = true;
        })
            .addMatcher(isPending(createCase, updateCase, deleteCase), state => {
            state.errorMessage = null;
            state.updateSuccess = false;
            state.updating = true;
        })
            .addMatcher(isRejected(getCases, getCase, createCase, updateCase, deleteCase), (state, action) => {
            state.loading = false;
            state.updating = false;
            state.updateSuccess = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset } = CaseManagementSlice.actions;
// Reducer
export default CaseManagementSlice.reducer;
